import { BMotion } from './BMotion';
import { BMotion2 } from './BMotion2';
import { Point, NumPair } from '../Misc/Utils';
import { BMotionType } from './BMotionEnums';
import { Constants } from '../Misc/Constants';
import { PointOps } from '../Graphics/PointOps';
import { KeyFrame } from '../KeyFrame/KeyFrame';

interface ScaleKeyFrame extends KeyFrame{
    scaleFactor: NumPair
}

export class Scale extends BMotion2{
    readonly TYPE: BMotionType = BMotionType.SCALE

    constructor(){
        super();
        this.createNewKeyFrame(0, [1,1]);
        this.prepare();
        /*this.addKeyFrame([2,2], 12, true);
        this.addKeyFrame([1.5,2], 24, true);
        this.addKeyFrame([1,1], 48, true);*/
    }

    interpolate(interpolant : number, prev: ScaleKeyFrame, next: ScaleKeyFrame) : NumPair{
        return PointOps.interpolate(
            prev.scaleFactor,
            next.scaleFactor,
            interpolant);
    }

    //override
    protected resetComputedVal(){
        var scale = (this.keyFrames.get(0) as ScaleKeyFrame).scaleFactor;
        this._computedVal = [scale[0], scale[1]];
    }

    protected updateKeyFrameVal(frameNumber: number, newValue: number[]): void {
        //Parent checks if frame is available before call this method. So key frame is guaranteed to be available.
        (this.keyFrames.get(frameNumber) as ScaleKeyFrame).scaleFactor = [newValue[0], newValue[1]];
    }
    protected createNewKeyFrame(frame: number, newValue: number[]): void {
        var scaleFactor = [newValue[0], newValue[1]];
        var interpolate = true;
        let keyFrame = {scaleFactor, frame, interpolate}
        this.keyFrames.add(frame, keyFrame)
    }

    clone(): BMotion2{
        var clone = new Scale()
        super.duplicate(clone);
        for(var keyFrame of this.keyFrames.getKeys()){
            var tkf = this.keyFrames.get(keyFrame) as ScaleKeyFrame;
            clone.updateKeyFrame(keyFrame, tkf.scaleFactor);
        }
        return clone;
    }
}